import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Copy from '../../../assets/copy.svg';
import Loading from '../../../assets/loading.gif';
import {QRCodeSVG} from 'qrcode.react';
import { getStrLang } from '../../Translate';
import 'jquery-ui-dist/jquery-ui';
import { callPicPayApi, getCrypto, getDeposit } from '../../../api/fastcoinService';
import toast, { Toaster } from 'react-hot-toast';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import 'jquery-ui-dist/jquery-ui';
import { MenuItem, Select, FormControl, InputLabel } from "@material-ui/core";

import $ from 'jquery';
import Timer from '../../Timer';

const PicPay = (props) => {

    let picpay_avaliable = true;
    const { translate, lang } = useLanguage();


    const [loadingPicPayInfo, setLoadingPicPayInfo] = useState(false);
    const [infoPicPay, setInfoPicPay] = useState(sessionStorage.getItem("picpay_info") !== null ? JSON.parse(sessionStorage.getItem("picpay_info")) : undefined);
    const [expirado, setExpirado] = useState(false);
    const [waitingPayment, setWaitingPayment] = useState(sessionStorage.getItem("waiting_payment") !== null ? JSON.parse(sessionStorage.getItem("waiting_payment")) : false);
    const [showQr, setShowQr] = useState(false)
    const [isError, setIsError] = useState(false)
    const [client_logo,set_client_logo]=useState('')

    useEffect(() => {
        translate();
    }, [translate]);

    useEffect(() => {
        if (infoPicPay !== undefined) {
            setInfoPicPay(infoPicPay);
            setShowQr(true)
        }
        const logoData=sessionStorage.getItem('client_logo')
        if(logoData){
            set_client_logo(logoData)
        }else{
            if(sessionStorage.getItem('is_white_label') === "true"){
            }else{
                set_client_logo('favicon.ico')
            }
        }
    }, [])


    const callPicPay = () => {
        setLoadingPicPayInfo(true);
        callPicPayApi(sessionStorage.getItem("order_no"))
            .then(res => {
                if (res !== undefined) {

                    setInfoPicPay(res);
                    sessionStorage.setItem("picpay_info", JSON.stringify(res));

                    setWaitingPayment(true);
                    setShowQr(true)

                    setLoadingPicPayInfo(false)
                } else {
                    setInfoPicPay({ error: "Please, talk with the Administrator." });
                    setLoadingPicPayInfo(false);
                }
            })
            .catch(err => {
                console.log(err.toString());
                setIsError(true)
            }).finally(() => {
                setLoadingPicPayInfo(false);
                translate();
            });
    }

    useEffect(() => {
        let timeout;
        function doEffect() {
            let ctrl = $("#message-crypto span");
            $(ctrl).css("display", "flex");
            $(ctrl).fadeIn(500, function () {
                ctrl.effect("pulsate", 15000).fadeOut(500);
                doEffect(ctrl);
            });

            let ctrl2 = $("#message-crypto2 span");
            $(ctrl2).css("display", "flex");
            $(ctrl2).fadeIn(500, function () {
                ctrl2.effect("pulsate", 15000).fadeOut(500);
                doEffect(ctrl2);
            });
        }
        function checkPayment() {
            timeout = setTimeout(function () {
                getDeposit(sessionStorage.getItem("order_no"))
                    .then(res => {
                        if (res.status.toLowerCase() === "paid") {
                            setWaitingPayment(false);
                            sessionStorage.setItem("waiting_payment", false);
                            window.location.replace(getURLBackToPanel());
                        } else {
                            checkPayment();
                        }
                    })
                    .catch(err => {
                        alert(err);
                        checkPayment();
                    })
            }, 30000);
        }
        if (waitingPayment) {
            doEffect();
            sessionStorage.setItem("waiting_payment", true);
            checkPayment();
        }
        return () => clearTimeout(timeout);
    }, [loadingPicPayInfo]);


    const notify = () => {
        navigator.clipboard.writeText(infoPicPay?.paymentUrl);
        toast.success(getStrLang(lang.nameLang, "notify_toast"));
    }

    useEffect(() => {
        if (infoPicPay === undefined) {
            callPicPay()
        }
    }, [])
    console.log("expirado", expirado)
    return (
        <>
            {loadingPicPayInfo && <div className="group-pix-content">
                <div className="pix-container">
                    <div className="grup-crypto-opt">
                        <div className="msg-pix">
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                        </div>
                    </div>
                </div>
            </div>}

            {!loadingPicPayInfo &&
                <div className="group-pix-content">
                    {!expirado &&
                        <div className="infoarea-pix">
                            <Timer countdown={120} setExpirado={setExpirado} />
                            <div id='message-crypto' className='infoarea-crypto-message'>
                                <span>{getStrLang(lang.nameLang, "waiting-payment-crypto")}</span>
                            </div>
                            <div className="form-pix-header">
                                {/*<img id="image-logo-tabs" src={Logo} alt={"Logo"} style={{width: "50%"}} /> */}
                            </div>
                        </div>}
                    <div className="pix-container">
                        {!expirado &&
                            <div className="grup-crypto-opt">
                                <div className="msg-pix">


                                    {picpay_avaliable ?
                                        <>
                                            {infoPicPay !== undefined && infoPicPay?.paymentUrl !== undefined ?
                                                <>


                                                    <br />
                                                    <QRCodeSVG value={infoPicPay?.paymentUrl} size={180} imageSettings={{src:client_logo,height:40,width:40}}/>
                                                    <br />
                                                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                                                        <a href={infoPicPay.paymentUrl} target='_blank'>{getStrLang(lang.nameLang, "payment_url")}</a>
                                                    </div>
                                                </>
                                                :
                                                <>

                                                </>
                                            }
                                            {/* <h4 className="div-info-pag" data-lang-str="information_pix"></h4>*/}
                                        </>
                                        :
                                        <h4 data-lang-str="information_pix"></h4>
                                    }
                                    {isError && <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                                        <h4>{getStrLang(lang.nameLang, "error_picpay")} {getStrLang(lang.nameLang, "error_boleto2")}</h4>
                                    </div>}

                                </div>
                            </div>
                        }

                    </div>
                </div>}

            {!loadingPicPayInfo && <>
                {expirado ?
                    <>
                        <p className="center footer_pix"><b>{getStrLang(lang.nameLang, "payment_expiration")}</b></p>
                    </>
                    :
                    <>
                        <div className="infoarea-pix">
                            <div style={{ width: "33%" }}></div>
                            <div id='message-crypto2' className='infoarea-crypto-message'>
                                <span>{getStrLang(lang.nameLang, "msg_picpay")}</span>
                            </div>
                            <div className="form-pix-header">
                                {/*<img id="image-logo-tabs" src={Logo} alt={"Logo"} style={{width: "50%"}} /> */}
                            </div>
                        </div>

                    </>
                }
            </>
            }

        </>

    )
}

export default PicPay;